import { getServerTime as getServerTimeFromLib } from '@/lib/aggregation';

export const getServerTime = async (timezone: string): Promise<string> => {
    return getServerTimeFromLib(timezone);
};
